import { toast } from "react-toastify";

let notificationCount = 0;

const toastOptions = {
    position: "bottom-right",
    autoClose: true,
    hideProgressBar: false,
    newestOnTop: true,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    theme: "colored",
};

const handleNotification = (data) => {
    const { type = 'info', message = 'Tienes una nueva notificación!', url } = data;

    // Las notificaciones de tipo 'notification_new_message' ya no se cuentan en localStorage.
    // El conteo de notificaciones no leídas lo maneja el componente NotificationBell vía MongoDB.
    // Solo mantenemos la lógica de toast visual para backward compatibility.

    // Si hay una URL, renderiza el mensaje como un enlace
    const content = url ? (
        <a href={url} rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
            {message}
        </a>
    ) : (
        message
    );

    // Muestra un toast diferente según el tipo de notificación
    switch (type) {
        case 'nueva-venta':
        case 'success':
            toast.success(content, toastOptions);
            break;
        case 'error':
            toast.error(content, toastOptions);
            break;
        case 'notification_new_message':
            toast.warn(content, toastOptions);
            break;
        case 'warning':
            toast.warn(content, toastOptions);
            break;
        case 'nuevo-pedido-ecommerce':
            // Notificación personalizada con estilo morado/magenta
            toast(content, {
                ...toastOptions,
                style: {
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: '#ffffff',
                    fontWeight: '600',
                    boxShadow: '0 8px 16px rgba(102, 126, 234, 0.4)',
                    border: '2px solid rgba(255, 255, 255, 0.3)'
                },
                progressStyle: {
                    background: 'rgba(255, 255, 255, 0.7)'
                },
                icon: '🛒'
            });
            break;
        case 'ecommerce_pregunta':
            toast(content, {
                ...toastOptions,
                style: {
                    background: 'linear-gradient(135deg, #fceabb 0%, #f8b500 100%)',
                    color: '#333333',
                    fontWeight: '600',
                    boxShadow: '0 8px 16px rgba(248, 181, 0, 0.4)',
                    border: '2px solid rgba(255, 255, 255, 0.5)'
                },
                progressStyle: {
                    background: 'rgba(51, 51, 51, 0.3)'
                },
                icon: '💬'
            });
            break;
        case 'ecommerce_foto':
            toast(content, {
                ...toastOptions,
                style: {
                    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                    color: '#ffffff',
                    fontWeight: '600',
                    boxShadow: '0 8px 16px rgba(0, 242, 254, 0.4)',
                    border: '2px solid rgba(255, 255, 255, 0.3)'
                },
                progressStyle: {
                    background: 'rgba(255, 255, 255, 0.7)'
                },
                icon: '📸'
            });
            break;
        case 'ecommerce_restock':
            toast(content, {
                ...toastOptions,
                style: {
                    background: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
                    color: '#333333',
                    fontWeight: '600',
                },
                icon: '🔔'
            });
            break;
        case 'ecommerce_stock_check':
            toast(content, {
                ...toastOptions,
                style: {
                    background: 'linear-gradient(135deg, #636363 0%, #a2a2a2 100%)',
                    color: '#ffffff',
                    fontWeight: '600',
                },
                icon: '📦'
            });
            break;
        default:
            toast.info(content, toastOptions);
            break;
    }
};

export default handleNotification;